/** @format */
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export enum AccessoriesChecklistFlagVariant {
    INLINE_QUOTE_EDITING = '2.1-inline-quote-editing',
    ACCESSORIES_CHECKLIST = '2.2-accessories-checklist',
}

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const ACCESSORIES_CHECKLIST_VARIANT_ORDER = [
    AccessoriesChecklistFlagVariant.INLINE_QUOTE_EDITING,
    AccessoriesChecklistFlagVariant.ACCESSORIES_CHECKLIST,
] as const;

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const ACCESSORIES_CHECKLIST_FEATURE_FLAG_DEFAULT =
    'LOVE-1153-(sell-journey-accessories-checklist)' as const;
